import { axiosInstance } from "helpers";

export async function getAllEnvironments(website_id) {
  return axiosInstance
    .get("allfeaturesettings", {
      params: {
        api_key: localStorage.getItem("apikey"),
        added_by: localStorage.getItem("user_id"),
        tab_hint: "Environments",
        website_id,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export async function updateEnvironment({ data, website_id }) {
  return axiosInstance
    .post("updatefeaturesettings", {
      api_key: localStorage.getItem("apikey"),
      added_by: localStorage.getItem("user_id"),
      system_status: 0,
      website_id,
      tab_hint: "Environments",
      environments_settings: data,
    })
    .then((res) => res.data)
    .catch((err) => err);
}
